<template>
    <div class="payment-methods div-offset-small-half">
        <div style="display: none">
            <input
                type="radio"
                name="payment_method"
                @change="$emit('payment-method-changed', 'paypal')"
                value="paypal"
                id="method_paypal"
            />
        </div>

        <!--<div class="row justify-content-between">

            <div class="col-lg-3 col-md-3 col-6 col-md text-center">
                <i class="pf pf-paypal" style="font-size: 48px;"></i>
            </div>

            <div class="col-lg-3 col-md-3 col-6 col-md text-center">
                <i class="pf pf-giropay" style="font-size: 48px;"></i>
            </div>

            <div class="col-lg-3 col-md-3 col-6 col-md text-center mt-4 mt-sm-0">
                <i class="pf pf-klarna" style="font-size: 48px;"></i>
            </div>

            <div class="col-lg-3 col-md-3 col-6 col-md text-center mt-4 mt-sm-0">
                <i class="pf pf-credit-card" style="font-size: 48px;"></i>
            </div>

            <div class="col-lg-2 col-md-4 col-6 text-center mt-4 mt-sm-0">
                <i class="pf pf-mastercard" style="font-size: 48px;"></i>
            </div>

        </div>-->
    </div>
</template>

<style scoped>
.pf {
    font-size: 35px;
}

.creditcard-icon {
    white-space: nowrap;
}

.img-radio-btn-group {
    position: relative;
}
.img-radio-btn {
    position: absolute;
    top: 50%;
    margin-top: -7.8px;
}

.img-label {
    width: calc(100% - 25px);
}

input[type='radio'] {
    transform: scale(1.2, 1.2);
}
</style>
<script>
export default {
    props: {
        small: Boolean,
    },
    mounted() {
        const paypalMethod = document.querySelector('#method_paypal');

        if (paypalMethod !== null) {
            paypalMethod.click();
        }
    },
};
</script>
